// EditScreeningTeamModal.tsx
import React, { useMemo, useState } from "react";
import api from "../../../api/axiosConfig";
import {
  ICenterConfig,
  IStation,
  IUser,
} from "../../../pages/Center Admin/WelcomeScreenPage";

interface EditScreeningTeamModalProps {
  centerConfig: ICenterConfig;
  editedStations: IStation[];
  setEditedStations: React.Dispatch<React.SetStateAction<IStation[]>>;
  refreshCenterConfig: () => Promise<void>;
  onClose: () => void;
}

const EditScreeningTeamModal: React.FC<EditScreeningTeamModalProps> = ({
  centerConfig,
  editedStations,
  setEditedStations,
  refreshCenterConfig,
  onClose,
}) => {
  const [saving, setSaving] = useState(false);

  const SWAPPABLE_STATIONS = ["NURSE1", "NURSE2", "NURSE3"];

  const todayDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date());

  /**
   * Dynamic User Pool
   */
  const assignableUsers = useMemo(() => {
    return centerConfig.stations
      .filter((station) => station.stationName !== "CENTER ADMIN")
      .flatMap((station) => station.users);
  }, [centerConfig]);

  /**
   * Dropdown Change
   */
  const handleUserChange = (stationId: string, selectedUserId: string) => {
    const selectedUser = assignableUsers.find(
      (user) => user.userId === selectedUserId,
    );

    if (!selectedUser) return;

    const updatedStations = [...editedStations];

    const targetStationIndex = updatedStations.findIndex(
      (s) => s.stationId === stationId,
    );

    if (targetStationIndex === -1) return;

    const currentUser = updatedStations[targetStationIndex].users[0];

    const sourceStationIndex = updatedStations.findIndex((station) =>
      station.users.some((u) => u.userId === selectedUserId),
    );

    if (sourceStationIndex === -1) return;

    updatedStations[targetStationIndex].users = [selectedUser];

    updatedStations[sourceStationIndex].users = [currentUser];

    setEditedStations(updatedStations);
  };

  /**
   * Save
   */
  const handleSave = async () => {
    try {
      setSaving(true);

      const token = sessionStorage.getItem("accessToken");

      const authHeaders = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const payload = {
        centerName: centerConfig.centerName,

        stations: editedStations,
      };

      await api.center_api.patch(
        `/api/v1/center/${centerConfig.centerId}/config`,
        payload,
        authHeaders,
      );

      await refreshCenterConfig();

      onClose();
    } catch (error) {
      console.error("Failed to update screening team", error);

      alert("Failed to update screening team.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="edit-team-modal-overlay">
      <div className="edit-team-modal">
        <div className="edit-team-header">
          <h2>Edit Screening Team</h2>
        </div>

        <div className="edit-team-info">
          <div>
            <strong>Center :</strong> {centerConfig.centerName}
          </div>

          <div>
            <strong>Date :</strong> {todayDate}
          </div>
        </div>

        <div className="edit-team-body">
          {editedStations.map((station) => {
            const currentUser = station.users[0];
            console.log(
              "stationId:",
              station.stationId,
              "stationName:",
              station.stationName,
            );

            return (
              <div className="station-row" key={station.stationId}>
                <div className="station-name">{station.stationName}</div>

                <select
                  value={currentUser?.userId || ""}
                  onChange={(e) =>
                    handleUserChange(station.stationId, e.target.value)
                  }
                >
                  {/* {station.stationName === "CENTER ADMIN"
                    ? station.users.map((user) => (
                        <option key={user.userId} value={user.userId}>
                          {user.userName}
                        </option>
                      ))
                    : assignableUsers.map((user) => (
                        <option key={user.userId} value={user.userId}>
                          {user.userName}
                        </option>
                      ))} */}

                  {SWAPPABLE_STATIONS.includes(station.stationName)
                    ? centerConfig.stations
                        .filter((s) => SWAPPABLE_STATIONS.includes(s.stationName))
                        .flatMap((s) => s.users)
                        .map((user) => (
                          <option key={user.userId} value={user.userId}>
                            {user.userName}
                          </option>
                        ))
                    : station.users.map((user) => (
                        <option key={user.userId} value={user.userId}>
                          {user.userName}
                        </option>
                      ))}
                </select>
              </div>
            );
          })}
        </div>

        <div className="edit-team-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>

          <button className="save-btn" onClick={handleSave} disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditScreeningTeamModal;
